import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MenuPermissionConfig, MenuPermissionActionEnum, TypeMerchantUserEnum } from 'app/models';
import { MenuHomeEnum } from 'app/components/home';
import { AppComponent } from 'app/app.component';

@Component({
    selector: 'partner-root',
    templateUrl: './partner-root.component.html',
    styleUrls: ['./partner-root.component.scss'],
    providers: [MessageService]
})
export class PartnerRootComponent implements OnInit {
    public menuEnum = MenuHomeEnum;
    public activeMenu: MenuHomeEnum = MenuHomeEnum.PartnerDashboard;

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    public menuPermissionActive!: string;

    public employeesMenuEnum = TypeMerchantUserEnum;

    constructor(private messageService: MessageService, public app: AppComponent) { }

    ngOnInit(): void {
    }

    public clickMenu(menuPermissionActive: string, menu: MenuHomeEnum) {
        this.menuPermissionActive = menuPermissionActive;
        this.activeMenu = menu;
    }
}
